import { SUPPORTED_LOCALES } from 'constants/locale';

export function isSupportedLanguage(lang: string) {
  return lang !== undefined && SUPPORTED_LOCALES.indexOf(lang) !== -1;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/locale.ts